import React from 'react';
import { useTranslations } from '@core/js/hooks/i18n';
import { WebContent } from '@core/js/components/system/WebContent';
import { useDTAG } from '@theme/js/hooks/useDTAG';

import style from './index.scss';

type TermsAndConditionsProps = {
    onClose: () => void,
}

const TermsAndConditions: React.FC<TermsAndConditionsProps> = React.memo(({ onClose }) => {
    const t = useTranslations('playtech.mobile.system.verification.');
    const termsWCID = useDTAG('TERMS_AND_CONDITIONS_WC_ID');

    return (
        <div className={style.container}>
            <div className={style.heading}>{t('terms.heading')}</div>
            <div onClick={onClose} className={style.closeIcon}></div>
            <div className={style.scrollBlock}>
                <WebContent id={termsWCID}></WebContent>
            </div>
        </div>
    );
});

export { TermsAndConditions };
